import type { ReactNode } from 'react';

export const symbol_for_you: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M615-487.5q69-8.5 129-25.5 21-8 38.5 5t17.5 35v287q0 19-10.5 34T762-130q-63 25-139 37.5T480-80q-67 0-143-12.5T198-130q-17-7-27.5-22T160-186v-287q0-22 17.5-35t38.5-5q60 17 129 25.5t135 8.5q66 0 135-8.5ZM740-190v-263q-53 14-124.5 24T480-419q-64 0-135.5-10T220-453v263q49 20 123.5 35T480-140q62 0 136.5-15T740-190ZM589.5-835.5Q634-791 634-726t-44.5 109.5Q545-572 480-572t-109.5-44.5Q326-661 326-726t44.5-109.5Q415-880 480-880t109.5 44.5Zm-43 176Q574-687 574-726t-27.5-66.5Q519-820 480-820t-66.5 27.5Q386-765 386-726t27.5 66.5Q441-632 480-632t66.5-27.5ZM480-742Zm0 445Z"
		/>
	</svg>
);
